// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1jvk261p .ak-renderer-extension-overflow-container{overflow-y:unset!important}\n._e4fq261p .ak-renderer-extension-overflow-container{overflow-x:unset!important}", ""]);
// Exports
module.exports = exports;
